import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AddressEmptyCheckService {

  public static isEmpty(addressLines: string[]): boolean {

    if (!addressLines) {
      return true;
    }

    let hasValue = false;
    addressLines.forEach(addressLine => {
      if (addressLine) {
        hasValue = hasValue || true;
      }
    });
    return !hasValue;
  }
}
